import { VariantCard } from "./enum";

const useStyles = ({ variantCard }: { variantCard?: VariantCard }) => {
    let style = {
        background: 'white',
        color: 'c_grey.main',
    }

    if (variantCard == VariantCard.ERROR) {
        style.background = 'c_red.100'
        style.color = 'c_red.200'
    }
    if (variantCard == VariantCard.SUCCESS) {
        style.background = 'c_green.100'
        style.color = 'c_green.main'
    }
    if (variantCard == VariantCard.REJECT) {
        style.background = 'c_red.main'
        style.color = 'white'
    }
    if (variantCard == VariantCard.ACTIVE) {
        style.background = 'secondary.100'
        style.color = 'white'
    }

    return {
        container: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
        },
        containerCard: ({ active, button, hover }: { active?: boolean; button?: boolean; hover?: boolean }) => ({
            display: 'flex',
            padding: '6px 10px',
            gap: 0.75,
            alignItems: 'center',
            width: '100%',
            margin: 0,
            ...variantCard && ({
                backgroundColor: style.background,
                '& .MuiTypography-root': {
                    color: style.color
                },
                '& .MuiSvgIcon-root': {
                    color: style.color
                },
            }),
            '& .icon-action-card': {
                fontSize: '40px',
                height: 'fit-content',
                display: 'flex',
                alignItems: 'center',
                '& .MuiSvgIcon-root': {
                    fontSize: 'inherit'
                }
            },
            transition: '.2s ease',
            ...active && ({
                backgroundColor: 'secondary.100',
                '& .MuiTypography-root': {
                    color: 'white'
                },
                '& .MuiSvgIcon-root': {
                    color: 'white'
                }
            }),
            ...button && ({
                cursor: 'pointer'
            }),
            ...hover && ({
                '&:hover': {
                    cursor: 'pointer',
                    boxShadow: '0px 2px 0px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 0px 4px 0px rgba(0,0,0,0.12)'
                    // backgroundColor: 'secondary.100',
                    // '& .MuiTypography-root': {
                    //     color: 'white'
                    // },
                    // '& .MuiSvgIcon-root': {
                    //     color: 'white'
                    // },
                    // '& .MuiIcon-root': {
                    //     color: 'white'
                    // }
                }
            }),
            '& .flex': { display: 'flex' },
            '& .justify-between': { justifyContent: 'space-between' },
            '& .item-center': { alignItems: 'center' },
            '& .gap-2': { gap: 2 },
            '& .w-full': { width: '100%' }
        })
    }
}

export { useStyles }
